import React from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import ValidationQueue from "./components/ValidationQueue";
import OvertimeQueue from "./components/OvertimeQueue";
import CorrectionQueue from "./components/CorrectionQueue";
import { usePendingCounts } from "../../api/queries/approvalQueries";
import usePermissions from "../../hooks/usePermissions";
import "./approvals.css";
import "../attendance/attendance.css";

const TABS = [
  {
    key: "validation",
    label: "Check-ins to validate",
    icon: "bi-patch-check",
    count: "validationCount",
    module: "attendance",
  },
  {
    key: "overtime",
    label: "Overtime",
    icon: "bi-clock-history",
    count: "overtimeCount",
    module: "overtime",
  },
  {
    key: "corrections",
    label: "Attendance corrections",
    icon: "bi-pencil-square",
    count: "correctionCount",
    module: "dtr",
  },
];

/**
 * Approver hub: DTRs per cut-off (multi-level), flagged check-ins and
 * overtime requests. Counts come from /dashboard/me.
 */
const ApprovalsPage = () => {
  const [params, setParams] = useSearchParams();
  // One tab per module the role can view (dtr / attendance / overtime)
  const { can } = usePermissions();
  const tabs = TABS.filter((t) => can(t.module));
  const first = tabs[0]?.key;
  const tab = tabs.some((t) => t.key === params.get("tab"))
    ? params.get("tab")
    : first;
  const counts = usePendingCounts();

  return (
    <Layout>
      <div className="container-fluid py-4 px-lg-4">
        <div className="mb-4">
          <h1 className="fw-bold text-dark m-0 page-title">Approvals</h1>
          <p className="text-muted small mb-0">
            Check-ins to validate, overtime and attendance corrections. One
            approval decides each request. DTR cut-offs are approved in Time →
            DTR.
          </p>
        </div>

        <div className="approval-tabs" role="tablist">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`approval-tab ${tab === t.key ? "active" : ""}`}
              onClick={() =>
                setParams(t.key === first ? {} : { tab: t.key }, {
                  replace: true,
                })
              }
            >
              <i className={`bi ${t.icon}`}></i> {t.label}
              <span
                className="approval-tab-count"
                aria-label={`${counts[t.count]} waiting`}
              >
                {counts[t.count]}
              </span>
            </button>
          ))}
        </div>

        {tab === "validation" && <ValidationQueue />}
        {tab === "overtime" && <OvertimeQueue />}
        {tab === "corrections" && <CorrectionQueue />}
      </div>
    </Layout>
  );
};

export default ApprovalsPage;
